import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  environment,
  MyHttpClientFactory,
  ResponseCasingEnum,
} from '@ups/xplat/core';
import {
  CycleCountConfig,
  GenerateCycleCountRequest,
  GenerateCycleCountResponse,
} from '../models/cycle-count-config.model';

const CYCLE_COUNT_CONFIG_URL = '/api/cycleCountConfig';
const CYCLE_COUNTS_URL = '/api/cycleCounts';

@Injectable({
  providedIn: 'root',
})
export class CycleCountConfigService {
  private http: HttpClient;

  constructor(httpClientFactory: MyHttpClientFactory) {
    this.http = httpClientFactory.createHttpClient(
      environment.urls.toolTrackerAPI,
      true,
      ResponseCasingEnum.CamelCase
    );
  }

  getConfigs(): Observable<CycleCountConfig[]> {
    return this.http.get<CycleCountConfig[]>(CYCLE_COUNT_CONFIG_URL);
  }

  updateConfig(config: CycleCountConfig): Observable<CycleCountConfig> {
    return this.http.put<CycleCountConfig>(
      `${CYCLE_COUNT_CONFIG_URL}/${config.warehouseId}`,
      config
    );
  }

  generateNow(
    request: GenerateCycleCountRequest
  ): Observable<GenerateCycleCountResponse> {
    return this.http.post<GenerateCycleCountResponse>(
      CYCLE_COUNTS_URL,
      request
    );
  }
}
